import { render, staticRenderFns } from "./goodsPriceUpdateDetail.vue?vue&type=template&id=64d7c958&scoped=true&"
import script from "./goodsPriceUpdateDetail.vue?vue&type=script&lang=js&"
export * from "./goodsPriceUpdateDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsPriceUpdateDetail.vue?vue&type=style&index=0&id=64d7c958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7c958",
  null
  
)

export default component.exports